import { Link } from "react-router-dom";
import { Shield, Phone } from "lucide-react";
import { BUSINESS } from "@/config/business";

export default function SiteFooter() {
  return (
    <footer id="footer" className="bg-[#1c3325] text-[#c3d1c6]">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10">
        <div className="flex flex-col justify-between gap-8 border-b border-white/10 pb-10 md:flex-row md:items-start">
          <div>
            <div className="flex items-center gap-2.5">
              <Shield className="h-7 w-7 text-[#f4f1e9]" strokeWidth={2} />
              <span className="font-display text-[22px] font-semibold text-[#f4f1e9]">
                {BUSINESS.brandName}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-[#9fb2a3]">
              {BUSINESS.legalName}
              <br />
              {BUSINESS.addressLine}
              <br />
              {BUSINESS.cityStateZip}
            </p>
          </div>

          <div className="flex flex-col gap-3 text-[15px]">
            <a
              href={BUSINESS.phoneHref}
              data-testid="footer-phone"
              className="inline-flex items-center gap-2 font-semibold text-[#f4f1e9] transition-opacity hover:opacity-75"
            >
              <Phone className="h-4 w-4" strokeWidth={2.2} />
              {BUSINESS.phoneDisplay}
            </a>
            <a
              href={`mailto:${BUSINESS.supportEmail}`}
              className="text-[#c3d1c6] transition-opacity hover:opacity-75"
            >
              {BUSINESS.supportEmail}
            </a>
            <div className="mt-2 flex gap-5">
              <Link
                to="/privacy"
                data-testid="footer-privacy-link"
                className="text-[#c3d1c6] underline-offset-4 transition-opacity hover:opacity-75 hover:underline"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                data-testid="footer-terms-link"
                className="text-[#c3d1c6] underline-offset-4 transition-opacity hover:opacity-75 hover:underline"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-8 space-y-4 text-[13px] leading-relaxed text-[#9fb2a3]">
          <p>
            {BUSINESS.brandName} helps business owners explore consolidation and
            restructuring options for merchant cash advance obligations. We are
            an advisory and consulting service — we are not a lender, law firm,
            or debt settlement company.
          </p>
          <p>
            This site is for informational purposes only and does not constitute
            legal, financial, tax, or accounting advice. Nothing here is a loan
            offer or an offer of credit, and no specific outcome, savings, or
            result is guaranteed. Results vary based on your individual
            circumstances and your funders. We recommend consulting a qualified
            attorney or financial advisor before entering into any agreement.
          </p>
          <p className="pt-2 text-[#7f9587]">
            &copy; {new Date().getFullYear()} {BUSINESS.legalName}. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
